import {
  Container,
  ContainerGutter,
  ContainerPadding
} from '@volkswagen-onehub/components-core';
import React from 'react';

type PageHeaderWrapperType = React.PropsWithChildren<{}>;

const PageHeaderWrapper = ({children}: PageHeaderWrapperType) => {
  return (
    <Container
      padding={{
        right: ContainerPadding.grid002,
        bottom: ContainerPadding.static200,
        left: ContainerPadding.grid002,
      }}
      gutter={ContainerGutter.static200}
      wrap="always"
    >
      {children}
    </Container>
  );
};

export default PageHeaderWrapper;
